import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { useSelector } from 'react-redux';
import Popover from 'researcher/components/Popover';
import { FapiaoStatus } from 'researcher/fapiao';
import { price } from 'researcher/helpers/price';
import { getLink } from 'shared/helper/link-helper';
import { T, useTranslate } from 'shared/helper/translate';
import InvoiceActions from './InvoiceActions';
var Invoice = function Invoice(_ref) {
  var allowsFapiaoProcessingAfterPayment = _ref.allowsFapiaoProcessingAfterPayment,
    enableSelection = _ref.enableSelection,
    invoice = _ref.invoice,
    onFapiaoCancelled = _ref.onFapiaoCancelled,
    selected = _ref.selected,
    updateSelections = _ref.updateSelections;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var invoiceCurrency = useSelector(function (_ref2) {
    var payment = _ref2.payment;
    return payment.currencies.find(function (currency) {
      return currency.isoCode === invoice.currency;
    });
  });
  var customerSupportLink = useSelector(function (_ref3) {
    var application = _ref3.application;
    return getLink({
      application: application,
      linkName: 'fapiaoCustomerSupportLink'
    });
  });
  var showCustomerSupportLink = useSelector(function (_ref4) {
    var application = _ref4.application;
    return application.currentLocalization.identity !== invoice.localization;
  });
  return /*#__PURE__*/React.createElement("tr", {
    className: "invoice-row ".concat(invoice.pendingWriteoff ? 'text-muted' : '')
  }, enableSelection ? /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: selected,
    onChange: function onChange(e) {
      return updateSelections(e.target.checked, [invoice.invoiceNumber]);
    }
  })) : null, /*#__PURE__*/React.createElement("td", {
    className: enableSelection ? 'ps-0' : ''
  }, invoice.formattedDate), /*#__PURE__*/React.createElement("td", null, invoice.pendingWriteoff ? /*#__PURE__*/React.createElement("a", {
    href: "/api/invoice/".concat(invoice.invoiceNumber, "/pdf?localization=").concat(invoice.localization)
  }, invoice.invoiceNumber, /*#__PURE__*/React.createElement(Popover, {
    content: "finalizing-invoice-message"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1 text-muted",
    icon: "fa-solid fa-circle-exclamation"
  }))) : /*#__PURE__*/React.createElement("a", {
    href: "/api/invoice/".concat(invoice.invoiceNumber, "/pdf?localization=").concat(invoice.localization)
  }, invoice.invoiceNumber)), /*#__PURE__*/React.createElement("td", {
    className: "d-none d-sm-table-cell"
  }, /*#__PURE__*/React.createElement(T, {
    source: invoice.orderDescription
  })), /*#__PURE__*/React.createElement("td", null, invoice.pendingWriteoff ? null : /*#__PURE__*/React.createElement("span", null, price(invoiceCurrency, invoice.balance > 0 ? invoice.balance : invoice.totalAmount))), allowsFapiaoProcessingAfterPayment ? /*#__PURE__*/React.createElement("td", null, showCustomerSupportLink ? /*#__PURE__*/React.createElement("a", {
    "aria-label": t('fapiao-status-consult-support'),
    href: customerSupportLink
  }, /*#__PURE__*/React.createElement(T, {
    source: "fapiao-status-consult-support"
  })) : /*#__PURE__*/React.createElement(FapiaoStatus, {
    fapiao: invoice.fapiao,
    fapiaoCreationUrl: "/researcher/invoices/".concat(invoice === null || invoice === void 0 ? void 0 : invoice.invoiceNumber, "/fapiao")
  })) : null, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(InvoiceActions, {
    onFapiaoCancelled: onFapiaoCancelled,
    invoice: invoice
  })));
};
export default Invoice;